export default "__VITE_ASSET__DQWrAfT3__"